import React from "react"
import SliceZone from "../../../../utils/SliceZone"
import { Container, Link } from "./CTAButton.styles"

export const CTAButton = ({ data }) => {
	const title = data.primary.button_title[0]?.text
	const link = data.primary.link?.url

	return (
		<Container>
			<Link href={link}>{title}</Link>
		</Container>
	)
}
